export const PAYMENT_LOAD_ERROR = 'Secure payment could not connect. Please retry, or open this page in Safari or Chrome.';

export function withPaymentLoadTimeout<T>(promise: Promise<T>, timeoutMs = 20_000): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(PAYMENT_LOAD_ERROR)), timeoutMs);
    promise.then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
  });
}
